import React, { useEffect, useRef, useState } from 'react';
import Marquee from 'react-fast-marquee';
import { detectMobile } from '../../utils/UiHelper';

const TextOrMarquee = ({
    children,
    string,
    checkCondition = false,
    additionalSymbolsWidth = 0,
    contentBoxSize = 0,
}) => {
    const containerRef = useRef(null);
    const contentRef = useRef(null);

    const [shouldScroll, setShouldScroll] = useState(false);
    const [isTouchPaused, setIsTouchPaused] = useState(false);

    const checkShouldScroll = () => {
        const containerWidth =
            contentBoxSize || containerRef.current?.offsetWidth || 0;
        const contentWidth = contentRef.current?.offsetWidth || 0;
        return contentWidth + additionalSymbolsWidth > containerWidth;
    };

    useEffect(
        () => {
            if (string && children) {
                setTimeout(() => {
                    setShouldScroll(checkShouldScroll());
                }, 100);
            }
        },
        [string, children, checkCondition, contentBoxSize]
    );

    useEffect(() => {
        const handleResize = () => {
            setShouldScroll(checkShouldScroll());
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleTouchStart = () => {
        setIsTouchPaused(true);
    };

    const handleTouchEnd = () => {
        setIsTouchPaused(false);
    };

    return (
        <div
            ref={containerRef}
            style={{ width: '100%', overflow: 'hidden' }}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            {/* прихований блок для вимірювання контенту */}
            <div
                ref={contentRef}
                style={{
                    visibility: 'hidden',
                    whiteSpace: 'nowrap',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    zIndex: 0,
                }}
            >
                {children}
            </div>

            {shouldScroll ? (
                <Marquee
                    play={!isTouchPaused}
                    pauseOnClick={!detectMobile()}
                    pauseOnHover={!detectMobile()}
                    delay={3}
                    speed={30}
                    gradient={false}
                >
                    <div
                        style={{
                            display: 'inline-block',
                            position: 'relative',
                            zIndex: 1,
                        }}
                    >
                        {children}
                    </div>
                </Marquee>
            ) : (
                <div style={{ whiteSpace: 'nowrap' }}>{children}</div>
            )}
        </div>
    );
};

export default TextOrMarquee;
